export const environment = {
  production: false,
  APP_CONSTANTS :'./assets/env-config/appConfig-env.json',
  path: 'app/'
}
